import { styled } from '@mui/material';

export const Container = styled('div')(({ theme }) => ({
  width: '100%',
  padding: '0.5rem',
  backgroundColor: theme.palette.primary.main,
}));
